import { render, staticRenderFns } from "./FormClosed.vue?vue&type=template&id=646fbc38&scoped=true"
import script from "./FormClosed.vue?vue&type=script&lang=js"
export * from "./FormClosed.vue?vue&type=script&lang=js"
import style0 from "./FormClosed.vue?vue&type=style&index=0&id=646fbc38&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "646fbc38",
  null
  
)

export default component.exports